<app-lms-modal-frame [title]="'Document Upload'" [pageHeadWidth]="900">
  <div modal-body>
    <div class="container-fluid center-screen">
        <table id="clientHeader" class="table table-fixed p-1 table-striped table-sm mb-1 shadow-2-strong rounded-1">
          <caption>Client Details</caption>
          <tbody class="field-4column-label">
            <tr>
              <td>First names</td>
              <td>{{clientDetails.firstName}}</td>

              <td>Surname</td>
              <td>{{clientDetails.lastName}}</td>
            </tr>

            <tr>
              <td>ID number</td>
              <td>{{clientDetails.idNumber}}</td>

              <td>Cell number</td>
              <td>{{clientDetails.cellNumber}}</td>
            </tr>
          </tbody>
        </table>
      <div class="card mt-1">
        <div class="card-body p-1">
          <div class="container-fluid center-screen">
            <!--
            NOTE TO ALL DEVELOPERS. DO NOT CHANGE ANYTHING ON THIS COMPONENT!!!
          -->

            <lms-table-wrapper class="center-screen mb-1" [config]="config">
              <table class="table table-striped p-1 table-fixed table-sm shadow-2-strong rounded-1">
                <caption>Document List</caption>
                <thead>
                  <tr>
                    <th class="col-document">Document</th>
                    <th class="col-fileN">File name</th>
                    <th>Upload date</th>
                    <th>Uploaded by</th>
                    <th class="col-view text-center" style="width: 8%;">View</th>
                    <th class="col-delete text-center" style="width: 8%;" *ngIf="!isReadOnly">Delete</th>
                  </tr>
                </thead>

                <tbody>
                  <tr *ngFor="let doc of lstDocuments | paginate: config;">
                    <td>{{doc.documentType}}</td>
                    <td style="text-overflow: ellipsis;">{{doc.originalFileName}}</td>
                    <td style="width: 130px;">{{covertDate(doc.uploadDate)}}</td>
                    <td style="width: 135px;">{{doc.userName}}</td>
                    <td style="width: 8%;" class="text-center">
                      <button lms-icon-button class="btn btn-floating btn-icon fs-6 fas" mdbRipple
                        (click)="onDownloadPdf(doc)">
                        <i class="fas fa-sm fa-fw fa-eye"></i>
                      </button>
                    </td>
                    <td *ngIf="canDeleteDocument(doc)" style="width: 8%;" class="text-center">
                      <button lms-icon-button class="btn btn-floating btn-icon fs-6 fas" mdbRipple (click)="deleteDocument(doc)">
                        <i class="fas fa-xs fa-trash-can"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </lms-table-wrapper>

            <div *ngIf="!isReadOnly" class=" ms-auto me-auto mb-1 w-75 ms-auto me-auto">
              <table class="table table-striped p-1 table-fixed table-sm shadow-2-strong rounded-1">
                <caption>Document Upload</caption>
                <tbody>
                  <tr>
                    <td>
                      <mdb-select mdbInput class="form-select select table-control has-cell-control"
                        style="width: 210px;" [formControl]="selectedDocTypeControl" required>
                        <mdb-option [value]="null">-- Select --</mdb-option>
                        <mdb-option *ngFor="let doc of requiredDocs" [value]="doc">{{doc.documentName}}</mdb-option>
                      </mdb-select>
                    </td>
                    <td>
                      <div class="input-group">
                        <input mdbInput type="file" class="form-control shadow-1-strong align-content-around py-2"
                          id="inputGroupFile02" aria-describedby="inputGroupFileAddon02"
                          (change)="onFileSelected($event)" accept="application/pdf" #fileSelector
                          aria-label="Submit" />
                        <button class="btn btn-primary" mdbWavesEffect type="button" id="inputGroupFileAddon02"
                          (click)="onDocumentSubmit()">
                          Submit
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
         </div> <!-- <div "card-body p-1> -->
      </div>
    </div>
  </div>
  <div modal-actions class="flex-container">
    <button type="button" class="btn btn-primary" mdbRipple (click)="close()">Close</button>
    <button type="button" *ngIf="clientStatus === 'REPEAT'" class="btn btn-primary ms-3"
      (click)="confirmDocumentScanningDetails()">
      <i class="fas fa-thumbs-up fa-fw me-1"></i> Confirm
    </button>
  </div>
</app-lms-modal-frame>
